import { Box, FlexBox, Stack } from '@ardoq/layout';
import { TraversalBuilderViewState } from '../types';
import { RequiredComponentsCommands } from './requiredComponentsCommands';
import { SmallGhostButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { ComponentType } from '../components/ComponentType';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { t, type I18nLocale } from '@ardoq/i18n';

type Props = {
  state: TraversalBuilderViewState['requiredComponentsState'];
  commands: RequiredComponentsCommands;
  i18nLocale: I18nLocale;
};

const RequiredComponentsSelection = ({
  state,
  commands,
  i18nLocale,
}: Props) => {
  if (!state) return null;

  return (
    <Box width="full">
      <Stack gap="small">
        {state.items.map(item => {
          return (
            <FlexBox
              key={item.nodeId}
              borderRadius="r4"
              borderWidth={1}
              padding="xsmall"
              paddingLeft="small"
              align="center"
              justify="space-between"
              onMouseOver={() => commands.highlightPath(item.nodeId)}
              onMouseLeave={() => commands.highlightPath(null)}
            >
              <FlexBox align="center" gap="xxsmall">
                <ComponentType {...state.traversalStartTypeMetaData} />
                <Icon iconName={IconName.ARROW_FORWARD} color={colors.icon} />
                <ComponentType {...item.componentTypeMetaData} />
              </FlexBox>
              <SmallGhostButton
                onClick={() => commands.removeRequiredComponent(item.nodeId)}
                onFocus={() => commands.highlightPath(item.nodeId)}
                onBlur={() => commands.highlightPath(null)}
              >
                <Icon iconName={IconName.DELETE} />
                <VisuallyHidden>
                  {t(
                    i18nLocale,
                    'viewpointBuilder:requiredComponents.delete',
                    'Delete'
                  )}
                </VisuallyHidden>
              </SmallGhostButton>
            </FlexBox>
          );
        })}
      </Stack>
    </Box>
  );
};

export { RequiredComponentsSelection };
